import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ViewerPrimaryColorUserStyle, ViewerSecondaryColorUserStyle } from '../../UserCustomization';
import svgInline from '../../SvgInline/SvgInline';
import addFolderIcon from '../../../shared/assets/icon-new-folder.svg';
import deleteFolderIcon from '../../../shared/assets/icon-trash.svg';
import renameFolderIcon from '../../../shared/assets/icon-edit.svg';
import saveIcon from '../../../shared/assets/icon-check-circle.svg';
import cancelIcon from '../../../shared/assets/icon-cancel.svg';

class FolderManagerComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      adding: false,
      deleting: false,
      editing: false,
      folderName: '',
      foldersSaved: [],
    };

    this.toggleAdding = this.toggleAdding.bind(this);
    this.toggleDeleting = this.toggleDeleting.bind(this);
    this.toggleEditing = this.toggleEditing.bind(this);

    this.relayAddFolder = this.relayAddFolder.bind(this);
    this.relayUpdateFolder = this.relayUpdateFolder.bind(this);
    this.relaySelectFolder = this.relaySelectFolder.bind(this);
    this.relayNewFolder = this.relayNewFolder.bind(this);
    this.relayRemoveFolder = this.relayRemoveFolder.bind(this);

    this.handleFolderNameEnter = this.handleFolderNameEnter.bind(this);
    this.updateFolderName = this.updateFolderName.bind(this);
  }

  componentWillMount() {
    const noFolders = this.props.folders.length === 0;
    this.setState(prevState => ({
      ...prevState,
      adding: noFolders,
    }));
    if (this.props.items && !noFolders) {
      const foldersSaved = this.props.folders.map(f => {
        const found = this.isPropertyInFolder(f.id, this.props.folders);
        return { ...f, saved: found };
      });
      this.setState({ foldersSaved });
    }
  }

  componentWillReceiveProps(nextProps) {
    const noFolders = nextProps.folders.length === 0;
    this.setState(prevState => ({
      ...prevState,
      adding: noFolders,
    }));
    if (this.props.items && !noFolders) {
      const foldersSaved = nextProps.folders.map(f => {
        const found = this.isPropertyInFolder(f.id, nextProps.folders);
        return { ...f, saved: found };
      });
      this.setState({ foldersSaved });
    }
  }

  toggleAdding() {
    this.setState(prevState => ({
      ...prevState,
      folderName: '',
      adding: !prevState.adding,
    }), () => {
      this.props.onStateChange(this.state);
      if (this.state.adding && this.folderName) {
        this.folderName.focus();
      }
    });
  }

  toggleDeleting() {
    this.setState(prevState => ({
      ...prevState,
      deleting: !prevState.deleting,
    }), () => {
      this.props.onStateChange(this.state);
    });
  }

  toggleEditing() {
    const { activeFolder, folders } = this.props;
    const [folder = {}] = folders.filter(f => f.id === activeFolder);
    const { name: folderName = '' } = folder;
    this.setState(prevState => ({
      ...prevState,
      folderName: !prevState.editing ? folderName : '',
      editing: !prevState.editing,
    }), () => {
      this.props.onStateChange(this.state);
      if (this.state.editing && this.folderName) {
        this.folderName.focus();
        this.folderName.select();
      }
    });
  }

  relayAddFolder() {
    if (this.props.mode === 'modal') {
      this.props.addFolder(this.state.folderName, true);
    } else {
      this.props.addFolder(this.state.folderName, false);
    }
    this.toggleAdding();
  }

  relayUpdateFolder() {
    this.props.updateFolder(this.props.activeFolder, this.state.folderName);
    this.toggleEditing();
  }

  relayNewFolder() {
    this.props.selectFolder('');
  }

  relayRemoveFolder() {
    this.props.removeFolder(this.props.activeFolder);
    this.toggleDeleting();
  }

  relaySelectFolder(e) {
    const { target: { value } } = e;

    this.props.selectFolder(value);
  }

  handleFolderNameEnter(e) {
    if (e.which === 13) {
      const { adding, editing } = this.state;
      if (adding) {
        this.relayAddFolder();
      } else if (editing) {
        this.relayUpdateFolder();
      }
    }
  }

  updateFolderName(e) {
    const { target: { value } } = e;
    this.setState(prevState => ({
      ...prevState,
      folderName: value,
    }));
  }

  handleManageFolderUpdate = (folderId, saved) => {
    const { items, itemType, saveItemToFolder, removeItemFromFolder } = this.props;
    const saver = saved ? removeItemFromFolder : saveItemToFolder;
    // console.log('handleManageFolderUpdate:', [items, itemType, saved, saver]);
    saver(items, itemType, folderId);
  }

  isPropertyInFolder = (folderId, folders) => {
    const { items, itemType } = this.props;
    const itemId = items[0]._id;
    const currentFolder = folders.filter(f => f.id === folderId);
    const includes = currentFolder ? currentFolder[0][itemType].includes(itemId) : false;
    return includes;
  }

  buildSelectDropdown = () => {
    const { supportsAllOption } = this.props;
    return (
      <ViewerPrimaryColorUserStyle domStyle="borderColor">
        <select
          value={this.props.activeFolder}
          onChange={this.relaySelectFolder}
        >
          {supportsAllOption && (
            <option value="--all--">-- All folders --</option>
          )}
          {this.props.folders.map(folder => (
            <option key={folder.id} value={folder.id}>{folder.name}</option>
          ))}
        </select>
      </ViewerPrimaryColorUserStyle>
    );
  };

  buildSelectSingleOption = () => (
    <div style={{ width: 300, fontSize: '1.6em' }}>
      {this.props.folders.filter(f => f.id === this.props.activeFolder).shift().name}
    </div>
  );

  buildSelectMultiple = () => (
    <div className="folder-manager-multiselect">
      <ul>
        <li className="list-header">
          <span><strong>Select</strong></span>
          <span><strong>Available Folders</strong></span>
        </li>
        {this.state.foldersSaved.map(f => {
          return (
            <li key={f.id}>
              <span>
                <input
                  type="checkbox"
                  id={`folder-${f.id}`}
                  checked={f.saved}
                  value={f.id}
                  onChange={() => this.handleManageFolderUpdate(f.id, f.saved)}
                />
              </span>
              <label htmlFor={`folder-${f.id}`}>
                {f.name}
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );

  buildSelectRenderChild = () => {
    const { selectType } = this.props;
    if (selectType === 'dropdown') {
      return this.buildSelectDropdown();
    } else if (selectType === 'multi') {
      return this.buildSelectMultiple();
    }
    return this.buildSelectSingleOption();
  }

  render() {
    const {
      supportsAdd,
      supportsDelete,
      supportsEdit,
      supportsSelect = true,
    } = this.props;
    return (
      <div className={`folder-manager ${this.props.className || ''}`}>
        {supportsAdd && this.state.adding && (
          <div className="my-folders">
            <input
              ref={input => { this.folderName = input; }}
              type="text"
              placeholder="Untitled Folder"
              value={this.state.folderName}
              onChange={this.updateFolderName}
              onKeyDown={this.handleFolderNameEnter}
            />
            <div className="favorites-manager-btn-wrapper">
              <ViewerSecondaryColorUserStyle domStyle="backgroundColor">
                <button
                  style={{ marginRight: 10 }}
                  className="btn"
                  type="button"
                  onClick={this.relayAddFolder}
                  disabled={!this.state.folderName}
                  title="Save"
                >
                  {/* Create */}
                  {svgInline(saveIcon)}
                  Save
                </button>
              </ViewerSecondaryColorUserStyle>
              {this.props.folders.length !== 0 && (
                <ViewerSecondaryColorUserStyle domStyle="backgroundColor">
                  <button
                    className="btn"
                    type="button"
                    onClick={this.toggleAdding}
                    title="Cancel"
                  >
                    {svgInline(cancelIcon)}
                    Cancel
                  </button>
                </ViewerSecondaryColorUserStyle>
              )}
            </div>
          </div>
        )}
        {supportsEdit && this.state.editing && (
          <div className="my-folders">
            <input
              ref={input => { this.folderName = input; }}
              type="text"
              placeholder="Untitled Folder"
              value={this.state.folderName}
              onChange={this.updateFolderName}
              onKeyDown={this.handleFolderNameEnter}
            />
            <div className="favorites-manager-btn-wrapper">
              <ViewerSecondaryColorUserStyle domStyle="backgroundColor">
                <button
                  style={{ marginRight: 10 }}
                  className="btn"
                  type="button"
                  onClick={this.relayUpdateFolder}
                  disabled={!this.state.folderName}
                  title="Save"
                >
                  {/* Update */}
                  {svgInline(saveIcon)}
                  Save
                </button>
              </ViewerSecondaryColorUserStyle>
              <ViewerSecondaryColorUserStyle domStyle="backgroundColor">
                <button
                  className="btn"
                  type="button"
                  onClick={this.toggleEditing}
                  title="Cancel"
                >
                  {svgInline(cancelIcon)}
                  Cancel
                </button>
              </ViewerSecondaryColorUserStyle>
            </div>
          </div>
        )}
        {supportsDelete && this.state.deleting && (
          <div>
            <span style={{ width: 300, marginRight: 10, marginTop: 10, fontSize: '1.4em' }}>
              Permanently delete this folder?
            </span>
            <div className="favorites-manager-btn-wrapper">
              <ViewerSecondaryColorUserStyle domStyle="backgroundColor">
                <button
                  style={{ marginRight: 10 }}
                  className="btn"
                  type="button"
                  onClick={this.relayRemoveFolder}
                  title="Delete Folder"
                >
                  {/* Delete */}
                  {svgInline(deleteFolderIcon)}
                  Delete
                </button>
              </ViewerSecondaryColorUserStyle>
              <ViewerSecondaryColorUserStyle domStyle="backgroundColor">
                <button
                  className="btn"
                  type="button"
                  onClick={this.toggleDeleting}
                  title="Cancel"
                >
                  {svgInline(cancelIcon)}
                  Cancel
                </button>
              </ViewerSecondaryColorUserStyle>
            </div>
          </div>
        )}
        {(!this.state.adding && !this.state.editing && !this.state.deleting) && (
          <div className="my-folders">
            {supportsSelect &&
              this.buildSelectRenderChild()
            }
            <div className="favorites-manager-btn-wrapper">
              {supportsAdd && (
                <ViewerSecondaryColorUserStyle domStyle="backgroundColor">
                  <button
                    style={{ marginRight: 10 }}
                    className="btn"
                    type="button"
                    onClick={this.toggleAdding}
                    title="Create New Folder"
                  >
                    {/* Create New Folder */}
                    {svgInline(addFolderIcon)}
                    Create
                  </button>
                </ViewerSecondaryColorUserStyle>
              )}
              {supportsEdit && (
                <ViewerSecondaryColorUserStyle domStyle="backgroundColor">
                  <button
                    style={{ marginRight: 10 }}
                    className="btn"
                    type="button"
                    onClick={this.toggleEditing}
                    title="Rename Folder"
                  >
                    {/* Rename Folder */}
                    {svgInline(renameFolderIcon)}
                    Rename
                  </button>
                </ViewerSecondaryColorUserStyle>
              )}
              {supportsDelete && (
                <ViewerSecondaryColorUserStyle domStyle="backgroundColor">
                  <button
                    style={{ marginRight: 10 }}
                    className="btn"
                    type="button"
                    onClick={this.toggleDeleting}
                    title="Delete Folder"
                  >
                    {/* Delete */}
                    {svgInline(deleteFolderIcon)}
                    Delete
                  </button>
                </ViewerSecondaryColorUserStyle>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

FolderManagerComponent.propTypes = {
  activeFolder: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  folders: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
  })),
  itemType: PropTypes.string,
  addFolder: PropTypes.func.isRequired,
  removeFolder: PropTypes.func.isRequired,
  selectFolder: PropTypes.func.isRequired,
  updateFolder: PropTypes.func.isRequired,
  className: PropTypes.string,
  selectType: PropTypes.string,
  supportsAdd: PropTypes.bool,
  supportsAllOption: PropTypes.bool,
  supportsDelete: PropTypes.bool,
  supportsEdit: PropTypes.bool,
  supportsSelect: PropTypes.bool,
  onStateChange: PropTypes.func,
  saveItemToFolder: PropTypes.func,
  removeItemFromFolder: PropTypes.func,
  mode: PropTypes.string,
};

FolderManagerComponent.defaultProps = {
  onStateChange: () => {},
};

export default FolderManagerComponent;



// WEBPACK FOOTER //
// ./src/components/Favorites/FolderManager/FolderManager.js